module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"reconciliationButton":"Lataa sovintosopimus (pdf)","reconciliationDocument":"Sovintosopimus"},"se":{"reconciliationButton":"Ladda förlikningsavtal (pdf)","reconciliationDocument":"Förlikningsavtal"},"en":{"reconciliationButton":"Download settlement agreement (pdf)","reconciliationDocument":"Settlement"}}')
  delete Component.options._Ctor
}
